import { Output } from "valibot";

import { BotInfoSchema } from "./schemas";

export const artificialWordByWordDelay = 30;

const botInfoConfigDefault = BotInfoSchema.object.bot_info_config.object;

export const defaultBotInfo: Output<typeof BotInfoSchema> = {
  id: "",
  bot_info_config: {
    show_post_chat_feedback: true,
    chatbot_color: "#705CF6",
    company_name: "Botsonic",
    company_logo: botInfoConfigDefault.company_logo.default,
    chatbot_avatar: botInfoConfigDefault.chatbot_avatar.default,
    welcome_message: botInfoConfigDefault.welcome_message.default,
    chatbot_subheading: "Our bot answers instantly",
    support_contact_number: null,
    is_show_chat_sonic_brand: true,
    button_icon: "",
    is_show_sources: true,
    widget_position: "right",
    is_open_on_initial_render: false,
    is_show_recaptcha: false,
    custom_placeholder: "Send a message...",
    show_starter_widget: false,
    hide_user_form: false,
    server_error_message: "Apologies, there seems to be a server error.",
    no_sources_message: botInfoConfigDefault.no_sources_message.default,
    show_floating_welcome_message: false,
  },
  bot_prompt_config: {
    generation_language: "en",
    is_conversational: false,
  },
};

export const defaultChatBotColor = "#705CF6";

export const allowedDashboardMessages = ["The bot is yet to be trained"];

export const allowedEverywhereMessages = ["Invalid host"];

export const tenantNotFoundMessage = "Requested tenant not found";

export const chatEndedDueToInactivityMessage = "CHAT_ENDED_DUE_TO_INACTIVITY";
